import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { GroupForm } from "@univdiam/ui/customComponents/GroupList/GroupForm"
// import api from '@/http/api'
import axios from "axios"

const API_BASE_URL = import.meta.env.VITE_SERVER_URL

export default function EditGroup() {
  const { id } = useParams()
  const navigate = useNavigate()
  const [initialData, setInitialData] = useState<any>(null)
  const [isSubmitting, setIsSubmitting] = useState(false)

  useEffect(() => {
    const fetchGroup = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/groups/${id}`)
        if (response.status === 200 && response.data) {
          const group = response.data.data
          console.log(group)
          // Map fields to your form shape
          setInitialData({
            group_id: group.group_id,
            name: group.name,
            code: group.code || "",
            status: group.status === 1 ? "1" : "0"
          })
        }
      } catch (err) {
        console.error("Failed to fetch group", err)
        alert("Error fetching group.")
        navigate("/Group")
      }
    }

    fetchGroup()
  }, [id, navigate])

  const handleUpdateGroup = async (data: any) => {
    setIsSubmitting(true)
    try {
      const response = await axios.put(`${API_BASE_URL}/api/groups/${id}`, data)
      if (response.status === 200) {
        alert("Group updated successfully!")
        navigate("/Group")
      }
    } catch (error: any) {
      console.error("Error updating group:", error)
      const message = error.response?.data?.error || error.response?.data?.message || "Failed to update group.";
      alert(message)
    } finally {
      setIsSubmitting(false)
    }
  }

  if (!initialData) return <p className="text-center p-10">Loading...</p>

  return (
    <div className="p-6 max-w-2xl mx-auto">
      <h1 className="text-2xl font-bold mb-6">Edit Group</h1>
      <GroupForm onSubmit={handleUpdateGroup} initialValues={initialData} isEdit isSubmitting={isSubmitting} />
    </div>
  )
}
